import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 402 → dispatch custom event so <UpgradeModal /> can render the fancy comparison.
let lastUpgradeAt = 0;
http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402 && typeof window !== "undefined") {
      const now = Date.now();
      if (now - lastUpgradeAt > 1500) {
        lastUpgradeAt = now;
        const detail = err.response.data?.detail || {};
        window.dispatchEvent(new CustomEvent("upgrade-required", { detail }));
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
